import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    dayPicker: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4,1fr)',
        gap: '5px',
        [theme.breakpoints.up('sm')]: {
            gap: '16px',
        },
        '& button': {
            borderRadius: theme.isFlyingFlowers ? spacing.xs : spacing.xxs,
            border: theme.isFlyingFlowers ? `1px solid ${colors.black[700]}` : `1px solid ${colors.grey.grey3}`,
            minWidth: 'initial',
            width: '100%',
            color: colors.grey.grey6,
            [theme.breakpoints.between('sm', 'md')]: {
                minWidth: 'initial',
                width: '100%',
            },
            [theme.breakpoints.up('lg')]: {
                minWidth: theme.isFlyingFlowers ? '254px' : '248px',
                maxWidth: theme.isFlyingFlowers ? '254px' : '248px',
                height: theme.isFlyingFlowers ? '108px' : '104px',
                justifyContent: 'initial',
                boxShadow: theme.isFlyingFlowers
                    ? '0px 2px 2px rgba(60, 60, 59, 0.48), 0px 4px 8px rgba(60, 60, 59, 0.16)'
                    : 'unset',
            },
            '& > div': {
                '& span': {
                    color: colors.grey.grey6,
                },
            },
        },
    },
    pccDatePickerContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
        width: 'initial',
        marginBottom: spacing.medium,
        [theme.breakpoints.up('md')]: {
            width: '100%',
            padding: '0 !important',
            position: 'initial',
            top: 'initial',
            zIndex: 'initial',
            overflow: 'initial',
        },
        [theme.breakpoints.up('lg')]: {
            padding: '0 !important',
            position: 'initial',
            top: 'initial',
            zIndex: 'initial',
            overflow: 'initial',
        },
    },
    activeStep: {
        borderBottom: `1px solid ${colors.grey.grey3}`,
        paddingBottom: spacing.medium + ' !important',
        [theme.breakpoints.up('md')]: {
            paddingBottom: spacing.xl + ' !important',
        },
    },
    noBorderBottom: {
        borderBottom: 'none',
    },
    showFullCalendar: {
        height: 'calc(100vh - 130px)',
        [theme.breakpoints.up('md')]: {
            height: '100%',
        },
    },
}));
export default useStyles;
